import { ChangeDetectionStrategy, Component, input, TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { StemFormGroup } from '../question-item-editor.model';
import { StemLabelDirective } from '../stem-label/stem-label.directive';

@Component({
  selector: 'dojo-question-item-editor-stem-template-container',
  template: `
    <ng-container
      *ngTemplateOutlet="
        stemViewerTemplate();
        context: {
          $implicit: stem(),
          stemIndex: stemIndex(),
          stemGroupIndex: stemGroupIndex(),
          stemLabel: stemLabelDirective.state.label
        }
      "
    ></ng-container>
  `,
  imports: [NgTemplateOutlet],
  hostDirectives: [StemLabelDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuestionItemEditorStemTemplateContainerComponent {
  constructor(readonly stemLabelDirective: StemLabelDirective) {}

  readonly stem = input.required<StemFormGroup>();
  readonly stemIndex = input.required<number>();
  readonly stemGroupIndex = input<number | null>(null);
  readonly stemLabel = input<string>();

  readonly stemViewerTemplate =
    input.required<
      TemplateRef<{ $implicit: StemFormGroup; stemLabel: string; stemIndex: number; stemGroupIndex: number | null }>
    >();
}
